import {useEffect, useState} from 'react'
import {getUserByToken} from '../core/_requests'
import * as authHelper from '../core/AuthHelpers'
import {useAuth} from '../core/Auth'
import axios from 'axios'
import {apiURL} from '../../../../_metronic/helpers'

const SsoPage = () => {
  const {saveAuth, setCurrentUser} = useAuth()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    authHelper.rememberDeskEmbed()
    const code = new URLSearchParams(window.location.search).get('code')
    if (!code) {
      setError('Missing sign-in code.')
      return
    }
    let cancelled = false
    axios
      .post(apiURL('/auth/sso/trader-redeem'), {code})
      .then(async (res) => {
        if (cancelled) return
        window.history.replaceState({}, '', '/auth/sso')
        saveAuth(res.data)
        authHelper.setupAxios(res.data.access_token)
        const user = await getUserByToken(res.data.access_token)
        if (user) setCurrentUser(user)
      })
      .catch(() => {
        if (!cancelled) {
          setError('This sign-in link is invalid or expired. Open Trader Desk from the console again.')
        }
      })
    return () => {
      cancelled = true
    }
  }, [saveAuth, setCurrentUser])

  return (
    <div className='text-center'>
      <h1 className='text-white fw-bolder mb-3'>Trader desk</h1>
      <div className='text-gray-500 fw-semibold fs-6'>
        {error || 'Signing you in…'}
      </div>
    </div>
  )
}

export {SsoPage}
